/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Theme } from "@mui/material";

export const ourServiceTabContentStyle = {
  ourServiceTabContent: (theme: Theme) => ({
    paddingLeft: 0,
    paddingRight: 0,
    [theme.breakpoints.up("lg")]: {
      paddingLeft: "8rem",
      paddingRight: "8rem",
    },
  }),
  image: (theme: Theme) => ({
    width: "75%",
    height: "auto",
    display: "block",
    margin: "0 auto",
    [theme.breakpoints.up("lg")]: {
      width: "100%",
    },
  }),
};
